import * as React from 'react';
import styled from "styled-components";
import * as section from '../components';

const Container = styled.section`
  opacity: 0;
  transition: opacity 1s;
`;

const Sections = styled.section`
  display: grid;
  gap: 40px;
  margin: 0 auto;
  max-width: 1340px;

  @media screen and (max-width: 1270px) {
    padding: 10px;
  }
`;

/**
 * render landing main page
 * @constructor
 */
export default function Main(): React.ReactElement {
  const ref = React.createRef<HTMLDivElement>();

  React.useEffect(() => {
    if (ref.current?.style) {
      ref.current.style.opacity = '1'
    }
  }, []);

  return (
    <Container ref={ref} className={'landingPage'}>
      <Sections>
        <section.Main />
        <section.Features />
        <section.Possibilities />
        <section.Resources />
      </Sections>
      <section.Tariffs />
      <Sections>
        <section.Stages />
      </Sections>
      <section.Footer />
    </Container>
  );
}
